import { Checkbox } from "@flat-ui";

interface Props {
  /** Whether the user wants to subscribe to the newsletter */
  shouldSubscribeToNewsletter: boolean;

  /** Function to update the subscription preference */
  setShouldSubscribeToNewsletter: (value: boolean) => void;
}

/** Renders a checkbox for subscribing to the Sphere XG newsletter during signup flows */
export function SignupNewsletterCheckbox({
  shouldSubscribeToNewsletter,
  setShouldSubscribeToNewsletter,
}: Props): JSX.Element {
  return (
    <Checkbox
      checked={shouldSubscribeToNewsletter}
      onChange={(event) => setShouldSubscribeToNewsletter(event.target.checked)}
      data-testid="newsletter-checkbox"
      label="I want to subscribe to the newsletter for updates on new features and more"
      controlSx={{
        alignItems: "center",
        display: "flex",
        mb: "4px",
      }}
    />
  );
}
